import React from 'react';

import { formatToPercents } from 'app/pages/loanApplication/LoanApplication.utils';
import { DollarIcon } from 'app/shared/componentsRestyled/coreDesignSystem/icons';

import { fixedTwoFractionDigitsExceptIntegerCurrencyOptions } from 'constants/loanApplication';
import { StatusColor, StatusEnum } from 'constants/status';
import { formatNumberToCurrencyString } from 'utils/number';
import { getCombinedPendingChangeKind } from 'utils/pendingChangeKind';
import { getPendingChangeKind } from 'utils/pendingChanges';

const PROPERTY_SUMMARY_CARDS_NAMES = {
  PITI: 'PITI',
  LTV_CLTV_HLTV: 'LTV/CLTV/HLTV',
};

export const getPropertySummaryInfoConfig = ({ loanPendingChanges, headerInfo }) => {
  const ltvsChangeKind = getCombinedPendingChangeKind(
    [loanPendingChanges.ltv, loanPendingChanges.cltv, loanPendingChanges.hltv].map(
      getPendingChangeKind,
    ),
  );

  return [
    {
      name: PROPERTY_SUMMARY_CARDS_NAMES.PITI,
      value: formatNumberToCurrencyString(
        headerInfo.piti ?? 0,
        fixedTwoFractionDigitsExceptIntegerCurrencyOptions,
      ),
      icon: <DollarIcon />,
      iconColor: StatusColor[StatusEnum.SUCCESS],
      changeKind: getPendingChangeKind(loanPendingChanges.piti),
    },
    {
      name: PROPERTY_SUMMARY_CARDS_NAMES.LTV_CLTV_HLTV,
      value: `${formatToPercents(headerInfo.ltv, true)} / ${formatToPercents(
        headerInfo.cltv,
        true,
      )} / ${formatToPercents(headerInfo.hltv, true)}`,
      icon: <DollarIcon />,
      iconColor: StatusColor[StatusEnum.SUCCESS],
      changeKind: ltvsChangeKind,
    },
  ];
};
